
$(function(){

    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const common = require('./_data/common.json');
    const getRecaptchaToken = require('./recaptchaHelper');

    // defaults
    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        crossDomain: true,
        xhrFields: {
            withCredentials: true
        }
    });

   // console.log("login page timeZoneName: " +  timeZoneName + " language " + language);

    // Kutsuttavat urit yhteen muuttujaan (objektiin), josta voidaan helposti nähdä mitä tässä js filussa käytetään. 
    const Uris = {
        admin : "https://console.youpret.com/",  //envSettings.server + "/admin",
        jsonAuthEmail : envSettings.server + "/json/auth/email",
        jsonAuthCode : envSettings.server + "/json/auth/code",
        jsonAuthTextMessage : envSettings.server + "/json/auth/textmessage"
    }

    $("#loginSendBtn").on("click", function(event)
    { 
        console.log("login with email and pass button pressed");

        event.preventDefault();

        if( $('#loginForm')[0].checkValidity()){
            setSendBtnDisabled($("#loginSendBtn"));

            let email = $("#loginEmail").val();
            let password = $("#loginPassword").val();

            Cookies.raw = true;
            let accessToken = Cookies.get("accessToken");
            Cookies.raw = false;


           // console.log(email + ' ' + password);

            $.ajax({
                url: Uris.jsonAuthEmail,
                method:"POST",
                data: JSON.stringify({email: email, password: password, accessToken: accessToken}),
                })
                .done(function( data ) {
                    console.log("login completed. redirect to app ");
                    console.log(data);
                    redirectToApp(data);
                    setSendBtnActive($("#loginSendBtn"));
                })
                .fail(function(err){
                    console.log("login failed..");
                   // console.log(err);
                   setSendBtnActive($("#loginSendBtn"));
                   showAlert("email");
                }
            );
        }
    });

    $("#loginPhoneSendCodeBtn").on("click", function(event)
    {
        setSendBtnDisabled($("#loginPhoneSendCodeBtn"));
        let code = $("#loginCode").val();
        let phoneNumber = $("#loginPhoneNumber").val();

        $.ajax({
            url: Uris.jsonAuthCode,
            method:"POST",
            data: JSON.stringify({ phoneNumber: phoneNumber, code: code})
        }) 
        .done(function( data ) {
            redirectToApp(data);
            setSendBtnActive($("#loginPhoneSendCodeBtn"));
        })
        .fail(function( err ) {
            setSendBtnActive($("#loginPhoneSendCodeBtn"));
            showAlert("modal");
        });
    });

    function redirectToApp(data){
        /*
        // printaa vastauksena tulleen jsonin
        console.log(data);

        // asettaa responsen jsonuista emailin ja accessTokenin selaimen cookieen.
        const { email, accessToken, language, site } = data;
        Cookies.raw = true;
        Cookies.set("accessToken", accessToken, {path: '/', sameSite: 'Lax'});
        Cookies.set("email", email, {path: '/', sameSite: 'Lax'});
        Cookies.set("youpretLang", language, {path: '/', sameSite: 'Lax'});
        Cookies.set("site", site || '', {path: '/', sameSite: 'Lax'});
        Cookies.raw = false;
        */

    //    alert('tries to redirect to admin');
        // ohjaa selaimen adminiin. Admin käyttää tunnistamisessa cookieen tallennettuja tietoja.
        if(data.redirectUrl) {
            window.location.href = data.redirectUrl;
        } else {
            window.location.href = Uris.admin;
        }
        // window.location.href = Uris.admin;
        //alert( "Data Loaded: " + data );
    }


    // Tämä tapahtuu, kun painetaan buttonia, jonka id loginPhoneSendBtn
    $("#loginPhoneSendBtn").on("click", function(event)
    {
        // tekee selaimen oletusvalidoinnin. Esim. kun inputille on merkattu required htmlssä
        if( $('#phoneLoginForm')[0].checkValidity()){

            // estää oletustoiminnan
            event.preventDefault();

            setSendBtnDisabled($("#loginPhoneSendBtn"));

            

            // hakee valuen inputista, jonka id loginPhoneNumber
            let phoneNumber = $("#loginPhoneNumber").val();
            
            // tulostaa selaimen lokiin
            console.log(phoneNumber);

            // Fetch reCAPTCHA token first, then include it in the POST request to pass backend validation
            getRecaptchaToken().then(function(token) {
                let requestData = { phoneNumber: phoneNumber };
                if (token) {
                    requestData.recaptchaToken = token;
                }

                $.ajax({
                    url: Uris.jsonAuthTextMessage,
                    method:"POST",
                    data: JSON.stringify(requestData)   
                }) 
                .done(function( data ) {
                    // näyttää bootstrap modalin
                    $('#phoneLoginModal').modal('show');
                    // käsittelee serveriltä tulleen vastauksen
                    console.log("called")
                    console.log(data);
                    //alert( "Data Loaded: " + data );
                    setSendBtnActive($("#loginPhoneSendBtn"));
                })
                .fail(function(err){
                    // console.log(err);
                    setSendBtnActive($("#loginPhoneSendBtn"));
                    showAlert("phone");
                });
            });
        }
            
    });

    function setSendBtnDisabled(button){

        button.prop("disabled",true);
        button.html(
         '<span class="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span> ' + common[language].loading + '...'
       );
    }

    function setSendBtnActive(button){
        button.prop("disabled",false);
        button.html(common[language].login);
        if(button = $("#loginPhoneSendCodeBtn")){
            button.html(common[language].continue);
        }
        
    }

    function showAlert(from){
        let number = $("#phoneSales").val();
        let numberCaption = $("#phoneSalesCaption").val();
        let space;
        let br;
        if(from === "email"){
            space = $("#alert-space")
            br="";
        }
        if(from === "phone"){
            space = $("#alert-space2")
            br="";
        }
        if(from === "modal"){
            space = $("#alert-space-modal")
            br= "<br>";
        }
        space.html(
          '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + common[language].alertSubmitFailed + '<a href="tel:'+number+'">'+numberCaption+'</a>.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>'  
        );
    }

});